import React from 'react'
import { AuthOutcomeMark } from '../../../shared/sso-workspace/auth-card'
import { ButtonPrimary, ButtonSecondary } from '../../../shared/component/button'
import { useReducedMotion } from '../../../shared/hooks/use-reduced-motion'

// The code ran out before it was approved: the outcome card's expired mark
// (auth-card.js, a clock in the warning tone), then what to do.
export const ExpiredView = ({ onClose, onRetry }) => {
  const reducedMotion = useReducedMotion()
  return (
    <div className="sw-workspace ld-expired">
      <div className="ld-expired__icon"><AuthOutcomeMark tone="warn" glyph="clock" still={reducedMotion} /></div>
      <div className="ld-expired__title">Code expired</div>
      <div className="ld-expired__subtitle">This code expired before it was approved.</div>
      <div className="ld-actions">
        <ButtonSecondary text="Close" onClick={onClose} />
        <ButtonPrimary text="Enter New Code" onClick={onRetry} />
      </div>
    </div>
  )
}
